/**
 * iOS Safari は focus した入力欄の font-size が 16px 未満だと画面全体を自動ズームする。
 * viewport meta に maximum-scale=1 を付けるとこの自動ズームだけが無効になり、
 * iOS 10 以降ユーザーのピンチズーム操作は maximum-scale を無視して引き続き可能。
 * Android Chrome は maximum-scale でピンチズーム自体がブロックされてしまうため、
 * iOS 判定した場合のみ実行時に付与する。
 */

export function isIosDevice(userAgent: string, maxTouchPoints: number): boolean {
  if (/iPhone|iPad|iPod/.test(userAgent)) return true
  // iPadOS 13+ は Macintosh を名乗るため、タッチポイント数で判別する
  return /Macintosh/.test(userAgent) && maxTouchPoints > 1
}

export function withMaximumScale(content: string): string {
  if (/maximum-scale/.test(content)) return content
  return content ? `${content}, maximum-scale=1` : "maximum-scale=1"
}

export function preventIosInputZoom(
  nav: Pick<Navigator, "userAgent" | "maxTouchPoints"> = navigator,
): void {
  if (!isIosDevice(nav.userAgent, nav.maxTouchPoints ?? 0)) return
  const meta = document.querySelector('meta[name="viewport"]')
  if (!meta) return
  meta.setAttribute("content", withMaximumScale(meta.getAttribute("content") ?? ""))
}
